// First, and before anything that can throw: errors during startup are the ones
// hardest to hear about any other way.
import "./config/instrument";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { App } from "./App";
import { playInteraction } from "./design/sound";
import { useAuth } from "./stores/auth";
import { useGame } from "./stores/game";

useAuth.getState().init().then(() => useGame.getState().init());

// Use qualifying native media gestures, in capture phase so a React handler
// cannot swallow the tap that authorises audio on iOS. `playInteraction`
// suppresses the synthetic click that follows a touchend.
window.addEventListener("touchend", playInteraction, true);
window.addEventListener("click", playInteraction, true);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
